import Echo from 'laravel-echo';
import { environment } from 'src/environments/environment';

export class YetiSocket {
	public static connect(): Echo<any> {
		// Realtime can be turned off per environment (`socketEnabled: false`).
		// mobile-api-v4 has no broadcast backend yet, so against those stacks the
		// socket only spams reconnect attempts at a dead host — return a no-op that
		// satisfies the callers (channel/leaveChannel/listen/stopListening) instead.
		if ((environment as { socketEnabled?: boolean }).socketEnabled === false) {
			return YetiSocket.disabled();
		}
		const echo = new Echo({
			broadcaster: 'socket.io',
			host: environment.socketHost,
		});
		if (!environment.production) {
			echo.connector.socket.on('connect', (data:any) => {
				console.log('connect', data);
			});
			echo.connector.socket.on('disconnect', (data:any) => {
				console.log('disconnect', data);
			});
			echo.connector.socket.on('reconnecting', (data:any) => {
				console.log('reconnecting', data);
			});
		}
		return echo;
	}

	// A chainable no-op standing in for an Echo instance when realtime is disabled.
	// Only the surface the event services use is implemented.
	private static disabled(): Echo<any> {
		const channel = {
			listen: () => channel,
			stopListening: () => channel,
		};
		const stub = {
			channel: () => channel,
			private: () => channel,
			leaveChannel: () => undefined,
			leave: () => undefined,
			disconnect: () => undefined,
		};
		return stub as unknown as Echo<any>;
	}
}
